export default __webpack_public_path__ + "static/media/boleto-expresso-example.5ae9eb5b.png";